import { render } from "./TextareaInput.vue?vue&type=template&id=4c0a63f8&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=ts"
export * from "./TextareaInput.vue?vue&type=script&lang=ts"

import "./TextareaInput.vue?vue&type=style&index=0&id=4c0a63f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c0a63f8"

export default script